export const activityConstants = {
  FETCHING_ACTIVITIES: 'FETCHING_ACTIVITIES',
  GET_ACTIVITIES_SUCCESS: 'GET_ACTIVITIES_SUCCESS',
  FETCHED_ACTIVITIES: 'FETCHED_ACTIVITIES',
  CLEAR_ACTIVITIES: 'CLEAR_ACTIVITIES'
};
